WiseMetering.Views.NewIndicator = WiseMetering.Views.Modal.Save.extend({
    className: 'mbx-info text-left',
    form_prefix: 'indicator',
    template: 'templates/indicators/new',
    title: () => i18next.t('modal.title.indicators.add'),

    ui: {
        site: 'select#indicator_site',
        container: '#type-container',
        kind: 'select#indicator_kind',
        name: '#indicator_name',
        type: 'select#indicator_type'
    },

    events: {
        'change select#indicator_site': 'onSiteChange',
        'change select#indicator_kind': 'onKindChange',
        'change select#indicator_type': 'onTypeChange'
    },

    afterSave: function() {
        WiseMetering.indicators.fetch();
    },

    onRender: function() {
        this.onKindChange();
    },

    serializeData: function() {
        return {
            isNew: true,
            site_id: this.model.get('site_id')
        };
    },

    getFormData: function() {
        const data = this.formSerializer();
        if (data.site_id === 'multi-site') {
            this.model.unset('site_id');
            delete data.site_id;
            data.organization_id = WiseMetering.currentOrganization.id;
        }

        if (data.type !== 'complex') {
            delete data.operation;
            this.model.unset('operation');
        }

        return data;
    },

    onSiteChange: function() {
        this.ui.type.attr('disabled', 'disabled');

        let site = this.ui.site.val();
        if (site === 'multi-site') {
            site = null;
        }
        this.model.set({ site_id: site });

        this.typeChange();
    },

    onKindChange: function() {
        const kind = WiseMetering.indicatorKinds.get(this.ui.kind.val());
        this.model.set({ kind_id: kind.id });
        this.$('#indicator_name').val(kind?.get('default') || '');
    },

    onTypeChange: function() {
        this.ui.kind.attr('disabled', 'disabled');
        const type = this.ui.type.val();
        this.model.set({ type });

        if (this.model.get('site_id')) {
            this.typeChange();
        } else {
            let sites = WiseMetering.zones.activeSites().map(site => ({ id: site.id, name: site.get('name') }));
            if (type === 'complex' && sites.length > 1) {
                sites.unshift({ id: 'multi-site', name: 'Multi Site' });
            }
            sites.unshift({ id: '', name: i18next.t('ui.please_select_option') });
            this.ui.site.html(WiseMetering.utils.optionsFromArray(sites));
        }
    },

    typeChange: function() {
        let view;
        switch (this.ui.type.val()) {
            case 'complex':
                view = new WiseMetering.Views.ComplexIndicator({ modal: this.modal, model: this.model });
                break;
            case 'etl':
                view = new WiseMetering.Views.EtlIndicator({ modal: this.modal, model: this.model });
                break;
            case 'mirror':
                view = new WiseMetering.Views.MirrorIndicator({ modal: this.modal, model: this.model });
                break;
            default:
                break;
        }

        if (view) {
            view.setElement(this.ui.container).render();
            this.modal.redraw();
        }
    }
});
